import React from 'react';
import ipCheck from "../sharecomponents/ipCheck";
import ipCheck2 from "../sharecomponents/ipCheck2";
class ManagerIpCheck extends React.Component{
    constructor(props){
        super(props);
        this.state = {Ip: '', IpCheck:''}
    }
    componentDidMount(){  
        ipCheck2().then((data)=>{
            if(data!=null && data.length>1){             
                this.setState({...this.state,Ip:data}) 
            }
        });      
        ipCheck().then((data)=>{
            if(data!=null && data.length>1){ 
               console.log(data)
                this.setState({...this.state,IpCheck:data}) 
            }
        });      
    }
    render(){
        return (

            <div className="bg-gradient-primary">            
                <div>
                    <div className="row  justify-content-center">
                        {this.state.Ip}
                    </div>
                    <div className="row  justify-content-center">
                        {this.state.IpCheck ==="UGIT"? "辦公室":"不認識"}
                    </div>
                </div>
            </div>
        );
    }
}

export default ManagerIpCheck;